import { useContext } from 'react';

import { OfferContext } from '@App/contexts/Offer';
import { ApplicationContext } from '@src/app/contexts/Application';
import { useCallBookingVariant } from '@src/app/hooks/useCallBookingVariant';
import useConversionTracking from '@src/app/hooks/useConversionTracking';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';
import FinaliseView from '@src/ui/views/offer/FinaliseView';

const Finalise = () => {
    const { applicationEmail } = useContext(ApplicationContext);
    const { loading } = useContext(OfferContext);
    const callBookingVariant = useCallBookingVariant();

    useConversionTracking(applicationEmail, 385995);

    return (
        <EligibilityLayout
            loading={loading || callBookingVariant === null}
            showTrustbarV2
        >
            <FinaliseView />
        </EligibilityLayout>
    );
};

export default Finalise;
